import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  getHomePageSection,
  getOptimizedHomePageSection,
} from 'hb-redux-store/feature/home/home.action';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import { HOMEPAGE_SECTIONS } from 'hb-redux-store/util/constantServices';
import BannerCarousel from 'components/web/BannerCarousel/BannerCarousel';
import Categories from 'components/web/Categories/Categories';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import Footer from 'components/web-feature/footer/index';
import LazySection from '../../common/LazySection/LazySection';

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homepageSection: {},
    };
  }

  componentDidMount() {
    this.props.getOptimizedHomePageSection();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.homepageSection !== this.props.homepageSection)
      this.setState({ homepageSection: this.props.homepageSection });
  }

  setHomepageUI = () => {
    const { homepageSection } = this.props;
    const sections =
      homepageSection &&
      homepageSection !== 'failed' &&
      homepageSection.map((s, sectionIndex) => {
        switch (s.type) {
          case HOMEPAGE_SECTIONS.BANNER_CUSTOM_TILES:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <BannerCarousel banners={s.sectionData.items} />
              </React.Fragment>
            );
          case HOMEPAGE_SECTIONS.CATEGORIES:
            return (
              <React.Fragment key={`${s.type}-${sectionIndex}`}>
                <LazySection
                  data={s}
                  sectionComponent={Categories}
                  sectionProps={{ deviceType: DEVICE_TYPE.DESKTOP }}
                />
              </React.Fragment>
            );
        }
      });
    return sections;
  };

  render() {
    const { loadingHomepage, homepageSection } = this.props;
    return (
      <Fragment>
        <div className="category-page-container">
          {loadingHomepage && <Loader />}
          {!loadingHomepage &&
            homepageSection &&
            homepageSection !== 'failed' &&
            this.setHomepageUI()}
        </div>
        {!loadingHomepage && <Footer />}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ homeReducer, initialReducer }) => ({
  homepageSection: homeReducer.homepageSection,
  loadingHomepage: homeReducer.loading,
  launchInfo: initialReducer.launchInfo,
});
const mapDispactchToProps = {
  getOptimizedHomePageSection,
};

export default connect(mapStateToProps, mapDispactchToProps)(Category);
